import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function NationalFeatureConceptDictionary() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
    <iframe
      src={t('NationalFeatureConceptDictionary_pdf')}
      title="PDF Document"
    />
  </div>
  );
}

export default NationalFeatureConceptDictionary;
